import { IEmployeeCheck } from "../employee-checks/IEmployeeCheck";
import { EDeductionType, DeductionTypeLabel } from "./EDeductionType";
import { toCase } from "../strings/toCase";

export const getDeductionTypeDisplayLabel = (deductionType: string): string =>
  DeductionTypeLabel[deductionType as EDeductionType] ??
  toCase(deductionType, "title");

export const getDeductionLabel = (
  deduction: IEmployeeCheck["deductions"][0]
) => {
  const label = deduction.deduction_template_name ?? "-";
  return `${label} (${getDeductionTypeDisplayLabel(deduction.deduction_type)})`;
};
